import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    { path: '/', name: 'intro', component: () => import('./views/IntroPage.vue') },
    { path: '/producten', name: 'Producten', component: () => import('./views/ProductsPage.vue') },
    { path: '/gordijnen', name: 'Gordijnen', component: () => import('./views/CurtainsPage.vue') },
    { path: '/rolgordijnen', name: 'Rolgordijnen', component: () => import('./views/RollCurtainsPage.vue') },
    { path: '/duette', name: 'Duettes / Plissé', component: () => import('./views/DuettePage.vue') },
    { path: '/jaloezien', name: 'Horizontale jaloeziën', component: () => import('./views/HorizontalBlindsPage.vue') },
    { path: '/duorol', name: 'Duorol', component: () => import('./views/DuoRolePage.vue') },
    { path: '/vergelijken', name: 'Vergelijken', component: () => import('./views/CompareProductsPage.vue')}
  ]
})
